/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fuehrungszeugnisid2Inputs */



/**

* @param {_Field_Fuehrungszeugnisid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fuehrungszeugnisid2 = /** @type {((inputs?: _Field_Fuehrungszeugnisid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fuehrungszeugnisid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Führungszeugnis")
});
export { _field_fuehrungszeugnisid2 as "_field_fuehrungszeugnisID" }